import { memo } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

function VerificationRoute() {
  const token = useSelector((state) => state.auth.token);
  const isEmailVerified = useSelector(
    (state) => state.auth.data?.user?.isEmailVarified
  );
  const isPhoneVerified = useSelector(
    (state) => state.auth.data?.user?.isPhoneVarified
  );
  const isVerified = isEmailVerified && isPhoneVerified;

  if (token && !isVerified) {
    return <Outlet />;
  }

  return <Navigate to="/login" />;
}

export default memo(VerificationRoute);
